import { useEffect } from "react";

/**
 * CopyAttribution — quando o usuário copia um trecho de conteúdo do site,
 * anexa ao final um aviso institucional + o link da página de origem. Ao
 * colar no WhatsApp, redes sociais ou e-mail, o crédito e o backlink vão
 * junto automaticamente.
 *
 * Regras de bom senso:
 *  - Só age em cópias "de conteúdo" (≥ MIN_CHARS caracteres) — ignora
 *    cópias curtas (uma palavra, um número, um link).
 *  - Não interfere em campos editáveis (input/textarea/contenteditable):
 *    o usuário está copiando o próprio texto, não o artigo.
 *  - Não age no painel administrativo (/admin) para não atrapalhar a
 *    cópia de links de afiliado, ASINs, etc.
 *  - O link é dinâmico: usa a URL canônica (<link rel="canonical">) da
 *    página atual, caindo para window.location.href se não houver.
 */
const MIN_CHARS = 40;

export default function CopyAttribution() {
  useEffect(() => {
    const handleCopy = (e) => {
      try {
        if (window.location.pathname.startsWith("/admin")) return;

        const selection = window.getSelection();
        const text = selection ? selection.toString() : "";
        if (!text || text.trim().length < MIN_CHARS) return;

        const el = document.activeElement;
        if (el && (el.tagName === "INPUT" || el.tagName === "TEXTAREA" || el.isContentEditable)) {
          return;
        }

        const canonical =
          document.querySelector('link[rel="canonical"]')?.href ||
          window.location.href;

        const clip = e.clipboardData || window.clipboardData;
        if (!clip) return;

        const notice =
          `Opa! Vimos que você copiou o texto. Sem problemas, desde que cite o link: ${canonical}`;

        // Texto puro (WhatsApp, notas, e-mail simples).
        const plain = `${text}\n\n— — —\n${notice}`;
        clip.setData("text/plain", plain);

        // Versão HTML com link clicável (editores ricos / Gmail / redes).
        const esc = (s) =>
          s
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;");
        const html =
          `${esc(text).replace(/\n/g, "<br>")}` +
          `<br><br>— — —<br>Opa! Vimos que você copiou o texto. Sem problemas, ` +
          `desde que cite o link: <a href="${esc(canonical)}">${esc(canonical)}</a>`;
        clip.setData("text/html", html);

        e.preventDefault();
      } catch {
        // Nunca quebra a cópia nativa em caso de erro.
      }
    };

    document.addEventListener("copy", handleCopy);
    return () => document.removeEventListener("copy", handleCopy);
  }, []);

  return null;
}
